import React from 'react';

import { theme } from 'config/theme';

const MAGENTA = theme.palette.primary.main;
const HANDLE_SIZE = 6;
const SEL_PAD = 21;

export default function SelectionHighlight({ figW, figH }: { figW: number; figH: number }) {
    const boxX = -figW / 2 - SEL_PAD;
    const boxY = -figH / 2 - SEL_PAD;
    const boxW = figW + SEL_PAD * 2;
    const boxH = figH + SEL_PAD * 2;

    const handles: [number, number][] = [
        [boxX, boxY],
        [boxX + boxW / 2, boxY],
        [boxX + boxW, boxY],
        [boxX, boxY + boxH / 2],
        [boxX + boxW, boxY + boxH / 2],
        [boxX, boxY + boxH],
        [boxX + boxW / 2, boxY + boxH],
        [boxX + boxW, boxY + boxH],
    ];

    return (
        <g pointerEvents="none">
            <rect
                x={boxX}
                y={boxY}
                width={boxW}
                height={boxH}
                fill="none"
                stroke={MAGENTA}
                strokeWidth={1.5}
                strokeDasharray="5 3"
                rx={3}
            />
            {handles.map(([hx, hy], idx) => (
                <rect
                    key={idx}
                    x={hx - HANDLE_SIZE / 2}
                    y={hy - HANDLE_SIZE / 2}
                    width={HANDLE_SIZE}
                    height={HANDLE_SIZE}
                    fill={MAGENTA}
                    stroke="white"
                    strokeWidth={1}
                />
            ))}
        </g>
    );
}
